// Origem da mercadoria: tabela do campo orig, MOC NF-e/NFC-e, grupo ICMS.
export const ORIGENS_PRODUTO = [
  ['0', 'Nacional, exceto as indicadas nos códigos 3, 4, 5 e 8'],
  ['1', 'Estrangeira — importação direta, exceto a indicada no código 6'],
  ['2', 'Estrangeira — adquirida no mercado interno, exceto a indicada no código 7'],
  ['3', 'Nacional, mercadoria ou bem com conteúdo de importação superior a 40% e inferior ou igual a 70%'],
  ['4', 'Nacional, cuja produção tenha sido feita em conformidade com os processos produtivos básicos de que tratam as legislações citadas nos Ajustes'],
  ['5', 'Nacional, mercadoria ou bem com conteúdo de importação inferior ou igual a 40%'],
  ['6', 'Estrangeira — importação direta, sem similar nacional, constante em lista da CAMEX e gás natural'],
  ['7', 'Estrangeira — adquirida no mercado interno, sem similar nacional, constante em lista da CAMEX e gás natural'],
  ['8', 'Nacional, mercadoria ou bem com conteúdo de importação superior a 70%']
].map(([value, description]) => ({ value, label: value + ' - ' + description }))

export function normalizarOrigemProduto(value) {
  if (value == null || String(value).trim() === '') return null
  const text = String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toUpperCase().replace(/\s+/g, ' ')
  if (/^[0-8]$/.test(text)) return text
  const prefix = /^([0-8])\s*[-–—]/.exec(text)
  if (prefix) return prefix[1]
  return ({
    NACIONAL: '0', 'IMPORTACAO DIRETA': '1', 'IMPORTACAO ADQUIRIDA NO MERCADO INTERNO': '2',
    // Textos gravados pela lista anterior de origens da tela de grupos tributários.
    'NACIONAL COM CONTEUDO DE IMPORTACAO > 40%': '3', 'NACIONAL - PROCESSOS PRODUTIVOS BASICOS': '4',
    'NACIONAL COM CONTEUDO DE IMPORTACAO <= 40%': '5', 'ESTRANGEIRA - IMPORTACAO DIRETA, SEM SIMILAR NACIONAL': '6',
    'ESTRANGEIRA - ADQUIRIDA MERCADO INTERNO, SEM SIMILAR NACIONAL': '7', 'NACIONAL COM CONTEUDO DE IMPORTACAO > 70%': '8'
  })[text] ?? null
}

export function labelOrigemProduto(value) {
  const code = normalizarOrigemProduto(value)
  return ORIGENS_PRODUTO.find(option => option.value === code)?.label || String(value ?? '—')
}
